// Local calendar date as YYYY-MM-DD — not toISOString(), which converts to
// UTC first and rolls the date back a day for part of the day in timezones
// ahead of UTC (e.g. IST).
export function todayLocalDateStr() {
  const d = new Date();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${m}-${day}`;
}

// Converts a "HH:MM" 24-hour string (as stored/returned by the gym booking
// API) to a "h:MM AM/PM" display string.
export function formatTime12h(hhmm) {
  if (!hhmm) return hhmm;
  const [h, m] = hhmm.split(':').map(Number);
  const period = h >= 12 ? 'PM' : 'AM';
  const hour12 = h % 12 || 12;
  return `${hour12}:${String(m).padStart(2, '0')} ${period}`;
}
